/**
 * SkipToContent — "Hoppa till innehåll" link shown on focus at top of page.
 * Visible only when focused (keyboard navigation). WCAG 2.1 AA §2.4.1.
 */
export function SkipToContent() {
  return (
    <a
      href="#main-content"
      className="sr-only fixed left-4 top-0 z-[9999] -translate-y-full rounded-lg bg-primary-600 px-4 py-2 text-sm font-medium text-white shadow-lg transition-transform focus:not-sr-only focus:translate-y-4 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-600 focus-visible:ring-offset-2"
    >
      Hoppa till innehåll
    </a>
  )
}
